/* ==========================================================================
   utopia-cart-builder.js  (Oct 2026, speed-up + build pop-up revision)

   Replaces addToCart1() from assets/theme.js. cartBuilder() in theme.js is
   unchanged: it hides the Add to Basket buttons, shows .loading, collects
   every checked radio/checkbox and calls addToCart1 straight away, by its
   global name, so it picks up this version automatically.

   SPEED-UP (17 Oct 2026)
   The original added a system one component at a time: one /cart/add.js
   request per part, each waiting for the last. This version sends the whole
   system in ONE /cart/add.js request using Shopify's items array.

   BUILD POP-UP (17 Oct 2026)
   The moment addToCart1 starts, the screen is greyed out and a card shows
   "Building your {name}" with a sequence of build messages and a yellow
   progress bar, on desktop and mobile. The bar eases towards 90% over the
   length of the message sequence and only completes when the basket is
   ready. It is driven by script, not a CSS transition, so theme-wide
   transition rules cannot make it jump ahead. Text colours and fonts are
   marked !important because the theme's own heading styles otherwise win.
   Heading, messages, timing and the small note are edited in the
   Configurator section of the Theme Editor (the data-ucfg-settings block);
   pages without that section use the built-in defaults below.
   The pop-up closes if the add fails (before the error message) and when the
   visitor comes back to the page with the browser Back button.

   TIMING LOG
   The browser console shows how long the add request took, e.g.
   "[utopia-cart] 18 items added in 1240 ms". Whatever remains of the wait
   after that is the basket page loading.

   WHAT IS UNCHANGED
   - Same variants, same order, quantity 1 each (duplicate parts still merge
     into one line with a higher quantity, exactly as before).
   - Same line properties: _groupCount, _groupID, _systemName, _systemImage,
     _shipDate. Missing values are sent as empty strings, as jQuery's form
     encoding did before.
   - Same redirect to /cart afterwards.

   FAILURE
   A multi-item add is all-or-nothing: if any variant is invalid, Shopify
   adds none of them. cartBuilderFailed() still runs as a safety net and
   removes any lines carrying this system's _groupID, restores the buttons
   and tells the customer what happened.

   WHY A SEPARATE FILE RATHER THAN EDITING theme.js
   theme.js is 166KB and theme files can only be written whole. This file is
   loaded from snippets/config-bar.liquid, which every configurator renders
   (rn-config-loader.js re-runs it when the configurator is fetched on
   demand). The old addToCart1 in theme.js is dead code.

   LOAD ORDER
   theme.js is loaded async, so on a page that renders the configurator
   inline this file can run first and theme.js would then redefine the old
   function. install() therefore runs immediately AND again on window load.
   Running more than once is safe.
   ========================================================================== */

(function () {
  'use strict';

  var PHONE = '01563 574280';

  var DEFAULTS = {
    heading: 'Building your {name}',
    note: 'Please keep this page open while we prepare your basket.',
    seconds: 1.5,
    messages: [
      'Gathering your components\u2026',
      'Seating the processor\u2026',
      'Fitting the memory\u2026',
      'Mounting the graphics card\u2026',
      'Routing the cables\u2026',
      'Checking every connection\u2026',
      'Preparing your basket\u2026',
      'Nearly there\u2026'
    ]
  };

  function str(v) {
    return v == null ? '' : v;
  }

  function now() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }

  /* ---- settings from the Configurator section ---------------------------- */

  function readSettings() {
    var out = {
      heading: DEFAULTS.heading,
      note: DEFAULTS.note,
      messages: DEFAULTS.messages,
      ms: DEFAULTS.seconds * 1000
    };
    var node = document.querySelector('[data-ucfg-settings]');
    if (!node) return out;
    try {
      var s = JSON.parse(node.textContent) || {};
      if (typeof s.build_messages === 'string') {
        var list = s.build_messages.split(/\r?\n/)
          .map(function (line) { return line.trim(); })
          .filter(function (line) { return line.length > 0; });
        if (list.length) out.messages = list;
      }
      var n = parseFloat(s.build_interval);
      if (n >= 0.5 && n <= 10) out.ms = n * 1000;
      if (typeof s.overlay_heading === 'string' && s.overlay_heading.trim()) out.heading = s.overlay_heading.trim();
      /* The note may be blanked in the Theme Editor to hide it. */
      if ('overlay_note' in s) out.note = (typeof s.overlay_note === 'string') ? s.overlay_note.trim() : '';
    } catch (e) { /* use the defaults */ }
    return out;
  }

  function systemName() {
    var node = document.querySelector('.sidebar .system-name') || document.querySelector('.system-name');
    var name = node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!name && window.jQuery) name = String(str(jQuery('.pagename').attr('type'))).trim();
    return name || 'PC';
  }

  /* ---- the build pop-up --------------------------------------------------- */

  var overlay = null;
  var fill = null;
  var timer = null;
  var raf = null;

  function injectStyle() {
    if (document.getElementById('ucb-overlay-style')) return;
    var light = '#f4f1ea';
    var fontHeavy = 'replica-Heavy,"Helvetica Neue",Arial,sans-serif';
    var fontRegular = 'replica-Regular,"Helvetica Neue",Arial,sans-serif';
    var s = document.createElement('style');
    s.id = 'ucb-overlay-style';
    s.textContent = [
      'html.ucb-lock,html.ucb-lock body{overflow:hidden}',
      '.ucb-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(8,8,7,.62);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);opacity:0;transition:opacity .25s ease}',
      '.ucb-overlay.is-open{opacity:1}',
      '.ucb-overlay .ucb-card{box-sizing:border-box;width:100%;max-width:440px;background:#1d1c19;border:1px solid rgba(244,241,234,.12);border-top:4px solid #f0cf1e;padding:32px 28px 26px;box-shadow:0 24px 70px rgba(0,0,0,.6);text-align:left;outline:none}',
      '.ucb-overlay .ucb-title{margin:0 0 18px!important;padding:0!important;font-family:' + fontHeavy + '!important;font-size:22px!important;font-weight:normal!important;line-height:1.2!important;letter-spacing:.02em!important;text-transform:uppercase!important;color:' + light + '!important;text-align:left!important}',
      '.ucb-overlay .ucb-msg{margin:0 0 18px!important;padding:0!important;min-height:1.5em;font-family:' + fontRegular + '!important;font-size:17px!important;line-height:1.5!important;color:' + light + '!important;transition:opacity .2s ease}',
      '.ucb-overlay .ucb-msg.is-swap{opacity:0}',
      '.ucb-overlay .ucb-bar{height:4px;background:rgba(244,241,234,.16);overflow:hidden}',
      '.ucb-overlay .ucb-bar__fill{height:100%;width:0;background:#f0cf1e;transition:none!important}',
      '.ucb-overlay .ucb-bar__fill.is-done{transition:width .3s ease!important}',
      '.ucb-overlay .ucb-note{margin:16px 0 0!important;padding:0!important;font-family:' + fontRegular + '!important;font-size:13px!important;line-height:1.5!important;color:rgba(244,241,234,.62)!important}',
      '@media (max-width:480px){.ucb-overlay .ucb-card{padding:26px 22px 22px}.ucb-overlay .ucb-title{font-size:19px!important}.ucb-overlay .ucb-msg{font-size:16px!important}}',
      '@media (prefers-reduced-motion:reduce){.ucb-overlay,.ucb-overlay .ucb-msg{transition:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Eases towards 90% over roughly the length of the message sequence and
     never reaches it on its own; completeOverlay() takes it to 100%. */
  function runBar(totalMs) {
    var start = now();
    function tick() {
      if (!fill) return;
      var t = now() - start;
      var pct = 90 * (1 - Math.exp(-2.3 * t / totalMs));
      fill.style.width = pct.toFixed(2) + '%';
      raf = window.requestAnimationFrame(tick);
    }
    raf = window.requestAnimationFrame(tick);
  }

  function showOverlay() {
    if (overlay) return;
    injectStyle();
    var cfg = readSettings();

    overlay = el('div', 'ucb-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ucb-overlay-title');

    var card = el('div', 'ucb-card');
    card.setAttribute('tabindex', '-1');
    var title = el('h2', 'ucb-title', cfg.heading.replace('{name}', systemName()));
    title.id = 'ucb-overlay-title';
    var msg = el('p', 'ucb-msg', cfg.messages[0]);
    msg.setAttribute('aria-live', 'polite');
    var bar = el('div', 'ucb-bar');
    bar.setAttribute('aria-hidden', 'true');
    fill = el('div', 'ucb-bar__fill');
    bar.appendChild(fill);

    card.appendChild(title);
    card.appendChild(msg);
    card.appendChild(bar);
    if (cfg.note) card.appendChild(el('p', 'ucb-note', cfg.note));
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    document.documentElement.classList.add('ucb-lock');

    window.setTimeout(function () {
      if (overlay) overlay.classList.add('is-open');
    }, 30);
    runBar(Math.max(cfg.messages.length * cfg.ms, 4000));
    try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }

    if (cfg.messages.length < 2) return;
    var index = 0;
    timer = window.setInterval(function () {
      if (index >= cfg.messages.length - 1) {
        /* Stay on the last message until the basket opens. */
        window.clearInterval(timer);
        timer = null;
        return;
      }
      index++;
      var next = cfg.messages[index];
      msg.classList.add('is-swap');
      window.setTimeout(function () {
        msg.textContent = next;
        msg.classList.remove('is-swap');
      }, 200);
    }, cfg.ms);
  }

  function completeOverlay() {
    if (raf) { window.cancelAnimationFrame(raf); raf = null; }
    if (!fill) return;
    fill.classList.add('is-done');
    fill.style.width = '100%';
  }

  function hideOverlay() {
    if (timer) { window.clearInterval(timer); timer = null; }
    if (raf) { window.cancelAnimationFrame(raf); raf = null; }
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    overlay = null;
    fill = null;
    document.documentElement.classList.remove('ucb-lock');
  }

  function resetButtons() {
    jQuery('.loading').addClass('hidden');
    jQuery('#addtocart1').removeClass('hidden');
    jQuery('#addtocart2').removeClass('hidden');
    jQuery(document.body).css({ cursor: 'default' });
  }

  /* ---- failure ----------------------------------------------------------- */

  function cartBuilderFailed(groupID, xhr) {
    var detail = '';
    try { detail = (xhr && xhr.responseJSON && xhr.responseJSON.description) || ''; } catch (e) { /* ignore */ }

    function finish(cleaned) {
      hideOverlay();
      resetButtons();
      window.alert(
        'Sorry, we couldn\u2019t add your system to the basket' + (detail ? ' (' + detail + ')' : '') + '. ' +
        (cleaned ? 'Nothing has been added. ' : 'Please check your basket before trying again. ') +
        'Try again, or call us on ' + PHONE + ' and we\u2019ll sort it for you.'
      );
    }

    jQuery.getJSON('/cart.js').done(function (cart) {
      var updates = {};
      var found = false;
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties._groupID === groupID) {
          updates[item.key] = 0;
          found = true;
        }
      });
      if (!found) { finish(true); return; }
      jQuery.ajax({
        url: '/cart/update.js',
        type: 'post',
        dataType: 'json',
        data: { updates: updates }
      }).done(function () { finish(true); })
        .fail(function () { finish(false); });
    }).fail(function () { finish(false); });
  }

  /* ---- add the whole system in one request -------------------------------- */

  function addToCart1(queue, groupCount, groupID) {
    showOverlay();

    var properties = {
      _groupCount: str(groupCount),
      _groupID: str(groupID),
      _systemName: str(jQuery('.pagename').attr('type')),
      _systemImage: str(jQuery('.sys-img').attr('src')),
      _shipDate: str(jQuery('.ship-date').html())
    };

    var items = [];
    while (queue.length) {
      var raw = queue.shift();
      if (raw == null || raw === '') continue;
      var id = parseInt(raw, 10);
      items.push({ id: isNaN(id) ? raw : id, quantity: 1, properties: properties });
    }

    if (!items.length) {
      cartBuilderFailed(groupID, null);
      return;
    }

    var started = now();
    jQuery.ajax({
      url: '/cart/add.js',
      type: 'post',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ items: items })
    }).done(function () {
      if (window.console) console.log('[utopia-cart] ' + items.length + ' items added in ' + Math.round(now() - started) + ' ms');
      completeOverlay();
      jQuery(document.body).css({ cursor: 'default' });
      window.location = '/cart';
    }).fail(function (xhr) {
      if (window.console) console.warn('[utopia-cart] add failed after ' + Math.round(now() - started) + ' ms', xhr && xhr.status);
      cartBuilderFailed(groupID, xhr);
    });
  }

  /* ---- install ------------------------------------------------------------- */

  function install() {
    window.addToCart1 = addToCart1;
    window.cartBuilderFailed = cartBuilderFailed;
  }

  install();
  if (document.readyState !== 'complete') {
    window.addEventListener('load', install);
  }

  /* Back from the basket restores the page from the browser cache with the
     pop-up and Loading button still showing. Reset both. */
  if (!window.__ucbPageshow) {
    window.__ucbPageshow = true;
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !window.jQuery) return;
      hideOverlay();
      resetButtons();
    });
  }
})();
